/*getting-started*/
/*create-microfrontendsjson*/
/*set-application-ports*/
/*handle-base-paths*/
/*run-turbo-dev*/
/*configuration*/
/*developmentlocal*/
/*developmentfallback*/
/*routing*/
/*exact-matches*/
/*parameters*/
/*wildcards*/
/*complex-routing-patterns*/
/*group-labels*/
/*packagename*/
/*optionslocalproxyport*/
/*integrating-with-production*/
/*microfrontends-on-vercel*/
/*migrating-to-vercelmicrofrontends*/
/*troubleshooting*/
/*port-already-in-use*/
/*missing-css-images-or-other-assets-or-routes-not-matching*/
/*links-across-applications-causing-errors*/
/*visiting-a-proxied-port-does-not-redirect*/
/*applications-not-starting*/
/*turbo-get-mfe-port-not-working*/
/*complete-example*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "微前端",
  "description": "了解如何使用 Turborepo 内置的微前端代理进行本地开发。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "微前端是一种架构模式，它将 Web 应用分解为更小的、独立开发和部署的应用，这些应用协同工作。"
  }, {
    "heading": "",
    "content": "¥Microfrontends are an architectural pattern where a web application is decomposed into smaller, independently developed and deployed applications that work together."
  }, {
    "heading": "",
    "content": "Turborepo 通过集成的代理服务器，为在开发过程中本地运行垂直微前端（有时称为 \"zones\"）提供了内置支持。代理协调多个应用并在它们之间路由流量。"
  }, {
    "heading": "",
    "content": "¥Turborepo provides built-in support for running vertical microfrontends (sometimes called \"zones\") locally during development through an integrated proxy server. The proxy coordinates multiple applications and routes traffic between them."
  }, {
    "heading": "",
    "content": "假设你有一个包含多个前端应用的单体仓库："
  }, {
    "heading": "",
    "content": "¥Let's imagine you have a monorepo with multiple frontend applications:"
  }, {
    "heading": "",
    "content": "在生产环境中，这些应用可以单独部署，然后使用反向代理或边缘路由组合在一起。但在开发过程中，你需要："
  }, {
    "heading": "",
    "content": "¥In production, these applications might be deployed separately and composed together using a reverse proxy or edge routing. But during development, you want to:"
  }, {
    "heading": "",
    "content": "使用单个命令同时运行所有应用"
  }, {
    "heading": "",
    "content": "¥Run all applications simultaneously with a single command"
  }, {
    "heading": "",
    "content": "通过统一 URL（例如 http://localhost:3024）访问它们"
  }, {
    "heading": "",
    "content": "¥Access them through a unified URL (e.g., http://localhost:3024)"
  }, {
    "heading": "",
    "content": "根据路径模式将请求路由到正确的应用"
  }, {
    "heading": "",
    "content": "¥Route requests to the correct application based on path patterns"
  }, {
    "heading": "",
    "content": "支持热模块重载和 WebSocket 连接。"
  }, {
    "heading": "",
    "content": "¥Support hot module reloading and WebSocket connections"
  }, {
    "heading": "",
    "content": "避免端口冲突和手动协调"
  }, {
    "heading": "",
    "content": "¥Avoid port conflicts and manual coordination"
  }, {
    "heading": "入门-getting-started",
    "content": "¥Getting started"
  }, {
    "heading": "入门-getting-started",
    "content": "Turborepo 提供了一个内置代理服务器，可在开发过程中自动路由微前端应用之间的流量。代理读取 microfrontends.json 配置文件，并在你运行 turbo dev 时启动。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥Turborepo provides a built-in proxy server that automatically routes traffic between your microfrontend applications during development. The proxy reads a microfrontends.json configuration file and starts when you run turbo dev."
  }, {
    "heading": "入门-getting-started",
    "content": "你可以尝试使用 npx create-turbo@latest -e with-microfrontends 创建的 monorepo 执行以下说明。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥You can try the following instructions with the monorepo created by npx\n    create-turbo@latest -e with-microfrontends."
  }, {
    "heading": "创建-microfrontendsjson-create-microfrontendsjson",
    "content": "¥Create microfrontends.json"
  }, {
    "heading": "创建-microfrontendsjson-create-microfrontendsjson",
    "content": "在父应用中创建 microfrontends.json 文件。当没有其他应用匹配时，所有请求都将回退到此应用。"
  }, {
    "heading": "创建-microfrontendsjson-create-microfrontendsjson",
    "content": "¥Create a microfrontends.json file in your parent application. This application is the one that all requests will fall through to when not matched by another application."
  }, {
    "heading": "设置应用端口-set-application-ports",
    "content": "¥Set application ports"
  }, {
    "heading": "设置应用端口-set-application-ports",
    "content": "接下来，使用 turbo get-mfe-port 命令在应用的开发脚本中设置端口。此命令在运行 turbo dev 时注入端口号："
  }, {
    "heading": "设置应用端口-set-application-ports",
    "content": "¥Next, use the turbo get-mfe-port command to set the ports in your application's development scripts. This command injects the port number when running turbo dev:"
  }, {
    "heading": "处理基本路径-handle-base-paths",
    "content": "¥Handle base paths"
  }, {
    "heading": "处理基本路径-handle-base-paths",
    "content": "如果你使用的是框架，请根据框架的要求设置基本路径。"
  }, {
    "heading": "处理基本路径-handle-base-paths",
    "content": "¥If you're using a framework, set the base path according to the needs of the framework."
  }, {
    "heading": "处理基本路径-handle-base-paths",
    "content": "有关框架特定指南，请参阅 访问框架的微前端部分。"
  }, {
    "heading": "处理基本路径-handle-base-paths",
    "content": "¥Visit the Microfrontends section of your framework for framework-specific guidance."
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "¥Run turbo dev"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "运行 turbo dev 时，Turborepo 将执行以下操作："
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "¥When you run turbo dev, Turborepo will:"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "在配置的端口上启动代理服务器（默认端口：3024）。"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "¥Start the proxy server on the configured port (default: 3024)"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "在任务中注入 TURBO_MFE_PORT 环境变量以设置应用的端口"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "¥Inject the TURBO_MFE_PORT environment variable in tasks to set the applications' port"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "为所有已配置的应用运行开发任务"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "¥Run development tasks for all configured applications"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "根据路径模式将传入请求路由到相应的应用"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "¥Route incoming requests based on path patterns to the appropriate application"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "现在，你可以通过 http://localhost:3024 访问所有微前端应用。"
  }, {
    "heading": "运行-turbo-dev-run-turbo-dev",
    "content": "¥Now you can access all of your microfrontends applications at http://localhost:3024."
  }, {
    "heading": "配置-configuration",
    "content": "¥Configuration"
  }, {
    "heading": "配置-configuration",
    "content": "applications 对象中的每个应用都可以具有以下属性："
  }, {
    "heading": "配置-configuration",
    "content": "¥Each application in the applications object can have the following properties:"
  }, {
    "heading": "配置-configuration",
    "content": "如果未提供，则使用应用密钥来匹配 package.json 中的名称。"
  }, {
    "heading": "配置-configuration",
    "content": "¥If not provided, the application key is used to match the name in `package.json."
  }, {
    "heading": "developmentlocal-developmentlocal",
    "content": "应用在本地运行的端口。"
  }, {
    "heading": "developmentlocal-developmentlocal",
    "content": "¥The port where the application runs locally."
  }, {
    "heading": "developmentlocal-developmentlocal",
    "content": "如果省略端口，Turborepo 将根据应用名称生成一个确定的端口（介于 3000 到 8000 之间）。"
  }, {
    "heading": "developmentlocal-developmentlocal",
    "content": "¥If you omit the port, Turborepo will generate a deterministic port based on the application name (between 3000-8000)."
  }, {
    "heading": "developmentfallback-developmentfallback",
    "content": "可选地，在应用未在本地运行时，提供要代理的目标。这最常用于将请求路由到生产环境，从而使像 turbo dev --filter=web 这样仅运行部分应用的命令获得无缝体验。"
  }, {
    "heading": "developmentfallback-developmentfallback",
    "content": "¥Optionally provide a target to proxy to when an application is not running locally. This is most frequently used to route to production to make commands like turbo dev --filter=web that only run a subset of applications a seamless experience."
  }, {
    "heading": "routing-routing",
    "content": "应路由到此应用的路径组数组。如果没有提供路由，则应用将成为默认应用，捕获所有未匹配的路由。"
  }, {
    "heading": "routing-routing",
    "content": "¥An array of path groups that should route to this application. If no routing is provided, the application becomes the default application that catches all unmatched routes."
  }, {
    "heading": "routing-routing",
    "content": "只能有一个应用没有 routing 配置。这是你的 \"root\" 应用，用于处理所有其他应用未匹配的路由。"
  }, {
    "heading": "routing-routing",
    "content": "¥Only one application can have no routing configuration. This is your \"root\" application that handles all routes not matched by other applications."
  }, {
    "heading": "routing-routing",
    "content": "路径区分大小写：/Blog 和 /blog 是不同的路由"
  }, {
    "heading": "routing-routing",
    "content": "¥Paths are case-sensitive: /Blog and /blog are different routes"
  }, {
    "heading": "routing-routing",
    "content": "尾部斜杠已规范化：/home 和 /home/ 匹配同一路由"
  }, {
    "heading": "routing-routing",
    "content": "¥Trailing slashes are normalized: /home and /home/ match the same route"
  }, {
    "heading": "精确匹配-exact-matches",
    "content": "¥Exact matches"
  }, {
    "heading": "精确匹配-exact-matches",
    "content": "这些路径与原文完全一致。"
  }, {
    "heading": "精确匹配-exact-matches",
    "content": "¥These paths match exactly as written."
  }, {
    "heading": "参数-parameters",
    "content": "¥Parameters"
  }, {
    "heading": "参数-parameters",
    "content": "以 : 开头的段匹配任何单个路径段。例如，/blog/:slug 匹配 /blog/hello，但不匹配 /blog/hello/world。"
  }, {
    "heading": "参数-parameters",
    "content": "¥Segments starting with : match any single path segment. For example, /blog/:slug matches /blog/hello but not /blog/hello/world."
  }, {
    "heading": "通配符-wildcards",
    "content": "¥Wildcards"
  }, {
    "heading": "通配符-wildcards",
    "content": "以 * 结尾的参数匹配零个或多个路径段。例如，/docs/:path* 匹配 /docs、/docs/intro 和 /docs/api/reference。"
  }, {
    "heading": "通配符-wildcards",
    "content": "¥Parameters ending with * match zero or more path segments. For example, /docs/:path* matches /docs, /docs/intro, and /docs/api/reference."
  }, {
    "heading": "通配符-wildcards",
    "content": "你还可以使用 + 修饰符来匹配一个或多个段（不包括空路径）："
  }, {
    "heading": "通配符-wildcards",
    "content": "¥You can also use the + modifier to match one or more segments (excluding the empty path):"
  }, {
    "heading": "通配符-wildcards",
    "content": "这匹配 /api/users 和 /api/users/123，但不匹配 /api 或 /api/。"
  }, {
    "heading": "通配符-wildcards",
    "content": "¥This matches /api/users and /api/users/123, but not /api or /api/."
  }, {
    "heading": "复杂的路由模式-complex-routing-patterns",
    "content": "¥Complex routing patterns"
  }, {
    "heading": "复杂的路由模式-complex-routing-patterns",
    "content": "你可以使用嵌套参数定义复杂的路由："
  }, {
    "heading": "复杂的路由模式-complex-routing-patterns",
    "content": "¥You can define sophisticated routing with nested parameters:"
  }, {
    "heading": "分组标签-group-labels",
    "content": "¥Group labels"
  }, {
    "heading": "分组标签-group-labels",
    "content": "将路由组织成逻辑组，以提高可维护性："
  }, {
    "heading": "分组标签-group-labels",
    "content": "¥Organize routes into logical groups for better maintainability:"
  }, {
    "heading": "分组标签-group-labels",
    "content": "group 字段用于组织管理，不影响路由行为。"
  }, {
    "heading": "分组标签-group-labels",
    "content": "¥The group field is for organizational purposes and doesn't affect routing behavior."
  }, {
    "heading": "packagename-packagename",
    "content": "可选地，使用工作区中 package.json 中的包名称。"
  }, {
    "heading": "packagename-packagename",
    "content": "¥Optionally use the name of the package from package.json in your workspace."
  }, {
    "heading": "optionslocalproxyport-optionslocalproxyport",
    "content": "可选地，使用 localProxyPort 选项更改代理端口"
  }, {
    "heading": "optionslocalproxyport-optionslocalproxyport",
    "content": "¥Optionally change the proxy port using the localProxyPort option"
  }, {
    "heading": "optionslocalproxyport-optionslocalproxyport",
    "content": "默认为 3024。"
  }, {
    "heading": "optionslocalproxyport-optionslocalproxyport",
    "content": "¥Defaults to 3024."
  }, {
    "heading": "与生产环境集成-integrating-with-production",
    "content": "¥Integrating with production"
  }, {
    "heading": "与生产环境集成-integrating-with-production",
    "content": "Turborepo 微前端代理仅供本地使用。你如何实现和集成生产微前端取决于你的生产基础架构。但是，我们可以集成你的本地环境和生产环境，从而创建跨环境的无缝体验。"
  }, {
    "heading": "与生产环境集成-integrating-with-production",
    "content": "¥The Turborepo microfrontends proxy is meant for local usage only. How you implement and integrate your production microfrontends depends on your production infrastructure. However, we can integrate your local and production environments to create a seamless experience across environments."
  }, {
    "heading": "与生产环境集成-integrating-with-production",
    "content": "首先，我们构建了 Turborepo 的本地代理，以便与 Vercel 的微前端集成。我们期待与任何有意集成 Vercel 的基础架构提供商合作。"
  }, {
    "heading": "与生产环境集成-integrating-with-production",
    "content": "¥To start, we've built Turborepo's local proxy to integrate with Vercel's microfrontends. We look forward to working with any infrastructure providers that would also like to integrate."
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "¥Microfrontends on Vercel"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "Vercel 原生支持以下微前端："
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "¥Vercel has native support for microfrontends that provide:"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "增强性能的生产代理实现"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "¥Production proxy implementation with enhance performance"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "跨环境的回退 URL 支持。"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "¥Fallback URL support across environments"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "Vercel 工具栏集成"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "¥Vercel toolbar integration"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "功能标志支持"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "¥Feature flag support"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "资源前缀处理"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "¥Asset prefix handling"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "Vercel 文档：了解更多信息。"
  }, {
    "heading": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "¥Learn more in Vercel's documentation."
  }, {
    "heading": "迁移到-vercelmicrofrontends-migrating-to-vercelmicrofrontends",
    "content": "¥Migrating to @vercel/microfrontends"
  }, {
    "heading": "迁移到-vercelmicrofrontends-migrating-to-vercelmicrofrontends",
    "content": "如果在任何包中安装 @vercel/microfrontends 或将其添加到你的工作区，Turborepo 将自动使用它，而不是使用内置代理。这允许逐步迁移。"
  }, {
    "heading": "迁移到-vercelmicrofrontends-migrating-to-vercelmicrofrontends",
    "content": "¥If you install @vercel/microfrontends in any package or add it to your workspace, Turborepo will automatically defer to it instead of using the built-in proxy. This allows for a gradual migration path."
  }, {
    "heading": "迁移到-vercelmicrofrontends-migrating-to-vercelmicrofrontends",
    "content": "你可以使用与 Turborepo 相同的 microfrontends.json 配置。Turborepo 的 microfrontends.json 架构是 Vercel 架构的子集，因此与 @vercel/microfrontends 兼容。"
  }, {
    "heading": "迁移到-vercelmicrofrontends-migrating-to-vercelmicrofrontends",
    "content": "¥You can use the same microfrontends.json configuration as for Turborepo. Turborepo's microfrontends.json schema is a subset of Vercel's schema, so it is compatible with @vercel/microfrontends."
  }, {
    "heading": "迁移到-vercelmicrofrontends-migrating-to-vercelmicrofrontends",
    "content": "了解更多关于 @vercel/microfrontends 和 访问 npm 上的软件包 的信息。"
  }, {
    "heading": "迁移到-vercelmicrofrontends-migrating-to-vercelmicrofrontends",
    "content": "¥To learn more about @vercel/microfrontends, visit the package on npm."
  }, {
    "heading": "故障排除-troubleshooting",
    "content": "¥Troubleshooting"
  }, {
    "heading": "端口已被占用-port-already-in-use",
    "content": "¥Port already in use"
  }, {
    "heading": "端口已被占用-port-already-in-use",
    "content": "默认情况下，微前端代理将尝试使用端口 3024。如果你已将该端口用于其他用途，则可以使用 options.localProxyPort 更改 Turborepo 的端口。"
  }, {
    "heading": "端口已被占用-port-already-in-use",
    "content": "¥By default, the microfrontends proxy will try to use port 3024. If you already use that port for a different purpose, you can change Turborepo's port using the options.localProxyPort."
  }, {
    "heading": "缺少-css图片或其他资源或路由不匹配-missing-css-images-or-other-assets-or-routes-not-matching",
    "content": "¥Missing CSS, images, or other assets, or routes not matching"
  }, {
    "heading": "缺少-css图片或其他资源或路由不匹配-missing-css-images-or-other-assets-or-routes-not-matching",
    "content": "确保微前端在其 routing 配置 中匹配的路径包含资源的路由。检查你的网络选项卡，查找与预期匹配或不匹配的路径。"
  }, {
    "heading": "缺少-css图片或其他资源或路由不匹配-missing-css-images-or-other-assets-or-routes-not-matching",
    "content": "¥Ensure that the paths that the microfrontends matches for in its routing configuration include the routes for the assets. Check your network tab to find paths that are or aren't matching as expected."
  }, {
    "heading": "跨应用的链接导致错误-links-across-applications-causing-errors",
    "content": "¥Links across applications causing errors"
  }, {
    "heading": "跨应用的链接导致错误-links-across-applications-causing-errors",
    "content": "如果使用单页应用 (SPA) 链接（例如 Next.js <Link> 组件）进行跨应用链接，则可能会导致错误。即使端口和域名保持不变，应用也是不同的。这意味着根据定义，该路由不是 \"单页应用\"。"
  }, {
    "heading": "跨应用的链接导致错误-links-across-applications-causing-errors",
    "content": "¥If you use a Single-Page Application (SPA) link (like the Next.js <Link> component) to link across applications, this can result in errors. Even though the port and domain remain the same, the applications are different. This means the routing is, by definition, not a \"single-page application\"."
  }, {
    "heading": "访问代理端口未重定向-visiting-a-proxied-port-does-not-redirect",
    "content": "¥Visiting a proxied port does not redirect"
  }, {
    "heading": "访问代理端口未重定向-visiting-a-proxied-port-does-not-redirect",
    "content": "你仍然可以直接访问代理端口。例如，如果 localhost:3000 被代理到 localhost:3042，你仍然可以在浏览器中访问 localhost:3000。"
  }, {
    "heading": "访问代理端口未重定向-visiting-a-proxied-port-does-not-redirect",
    "content": "¥You are still be able to reach a proxied port directly. For example, if localhost:3000 is proxied to localhost:3042, you can still visit localhost:3000 in your browser."
  }, {
    "heading": "访问代理端口未重定向-visiting-a-proxied-port-does-not-redirect",
    "content": "如果你希望 localhost:3000 重定向到 localhost:3024，则必须在应用中手动设置。"
  }, {
    "heading": "访问代理端口未重定向-visiting-a-proxied-port-does-not-redirect",
    "content": "¥If you would like for localhost:3000 to redirect to localhost:3024, you must set this up manually in your application."
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "¥Applications not starting"
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "验证以下内容："
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "¥Verify that:"
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "packageName 与你的实际包名匹配。"
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "¥The packageName matches your actual package name"
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "指定的 task 存在于包的 package.json 中。"
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "¥The task specified exists in the package's package.json"
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "每个应用的端口都可用。"
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "¥Each application's port is available"
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "所有依赖均已安装"
  }, {
    "heading": "应用无法启动-applications-not-starting",
    "content": "¥All dependencies are installed"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "¥turbo get-mfe-port not working"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "如果在运行 turbo get-mfe-port 时遇到错误，请确保："
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "¥If you're getting an error when running turbo get-mfe-port, ensure that:"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "你正在从包目录（而非仓库根目录）运行命令。"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "¥You're running the command from a package directory (not the repository root)"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "包的 package.json 中包含 name 字段。"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "¥The package has a name field in its package.json"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "某个包中存在 microfrontends.json 文件"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "¥A microfrontends.json file exists in one of the packages"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "当前包列在 microfrontends.json 的 applications 部分。"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "¥The current package is listed in the applications section of microfrontends.json"
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "如果使用 --skip-infer，则还必须指定指向仓库根目录的 --cwd："
  }, {
    "heading": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "¥If using --skip-infer, you must also specify --cwd pointing to your repository root:"
  }, {
    "heading": "完整示例-complete-example",
    "content": "¥Complete example"
  }, {
    "heading": "完整示例-complete-example",
    "content": "以下是一个完整的电子商务平台微前端配置示例："
  }, {
    "heading": "完整示例-complete-example",
    "content": "¥Here's a full example of a microfrontends configuration for an e-commerce platform:"
  }, {
    "heading": "完整示例-complete-example",
    "content": "使用此配置："
  }, {
    "heading": "完整示例-complete-example",
    "content": "¥With this configuration:"
  }, {
    "heading": "完整示例-complete-example",
    "content": "web 应用处理首页和任何未匹配的路由。"
  }, {
    "heading": "完整示例-complete-example",
    "content": "¥The web app handles the homepage and any unmatched routes"
  }, {
    "heading": "完整示例-complete-example",
    "content": "docs 应用处理所有文档。"
  }, {
    "heading": "完整示例-complete-example",
    "content": "¥The docs app handles all documentation"
  }, {
    "heading": "完整示例-complete-example",
    "content": "blog 应用处理博客文章和作者页面。"
  }, {
    "heading": "完整示例-complete-example",
    "content": "¥The blog app handles blog posts and author pages"
  }, {
    "heading": "完整示例-complete-example",
    "content": "shop 应用处理电子商务功能。"
  }, {
    "heading": "完整示例-complete-example",
    "content": "¥The shop app handles e-commerce functionality"
  }],
  "headings": [{
    "id": "入门-getting-started",
    "content": "入门 /*getting-started*/"
  }, {
    "id": "创建-microfrontendsjson-create-microfrontendsjson",
    "content": "创建 microfrontends.json /*create-microfrontendsjson*/"
  }, {
    "id": "设置应用端口-set-application-ports",
    "content": "设置应用端口 /*set-application-ports*/"
  }, {
    "id": "处理基本路径-handle-base-paths",
    "content": "处理基本路径 /*handle-base-paths*/"
  }, {
    "id": "运行-turbo-dev-run-turbo-dev",
    "content": "运行 turbo dev /*run-turbo-dev*/"
  }, {
    "id": "配置-configuration",
    "content": "配置 /*configuration*/"
  }, {
    "id": "developmentlocal-developmentlocal",
    "content": "development.local /*developmentlocal*/"
  }, {
    "id": "developmentfallback-developmentfallback",
    "content": "development.fallback /*developmentfallback*/"
  }, {
    "id": "routing-routing",
    "content": "routing /*routing*/"
  }, {
    "id": "精确匹配-exact-matches",
    "content": "精确匹配 /*exact-matches*/"
  }, {
    "id": "参数-parameters",
    "content": "参数 /*parameters*/"
  }, {
    "id": "通配符-wildcards",
    "content": "通配符 /*wildcards*/"
  }, {
    "id": "复杂的路由模式-complex-routing-patterns",
    "content": "复杂的路由模式 /*complex-routing-patterns*/"
  }, {
    "id": "分组标签-group-labels",
    "content": "分组标签 /*group-labels*/"
  }, {
    "id": "packagename-packagename",
    "content": "packageName /*packagename*/"
  }, {
    "id": "optionslocalproxyport-optionslocalproxyport",
    "content": "options.localProxyPort /*optionslocalproxyport*/"
  }, {
    "id": "与生产环境集成-integrating-with-production",
    "content": "与生产环境集成 /*integrating-with-production*/"
  }, {
    "id": "vercel-上的微前端-microfrontends-on-vercel",
    "content": "Vercel 上的微前端 /*microfrontends-on-vercel*/"
  }, {
    "id": "迁移到-vercelmicrofrontends-migrating-to-vercelmicrofrontends",
    "content": "迁移到 @vercel/microfrontends /*migrating-to-vercelmicrofrontends*/"
  }, {
    "id": "故障排除-troubleshooting",
    "content": "故障排除 /*troubleshooting*/"
  }, {
    "id": "端口已被占用-port-already-in-use",
    "content": "端口已被占用 /*port-already-in-use*/"
  }, {
    "id": "缺少-css图片或其他资源或路由不匹配-missing-css-images-or-other-assets-or-routes-not-matching",
    "content": "缺少 CSS、图片或其他资源，或路由不匹配 /*missing-css-images-or-other-assets-or-routes-not-matching*/"
  }, {
    "id": "跨应用的链接导致错误-links-across-applications-causing-errors",
    "content": "跨应用的链接导致错误 /*links-across-applications-causing-errors*/"
  }, {
    "id": "访问代理端口未重定向-visiting-a-proxied-port-does-not-redirect",
    "content": "访问代理端口未重定向 /*visiting-a-proxied-port-does-not-redirect*/"
  }, {
    "id": "应用无法启动-applications-not-starting",
    "content": "应用无法启动 /*applications-not-starting*/"
  }, {
    "id": "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
    "content": "turbo get-mfe-port 无法正常工作 /*turbo-get-mfe-port-not-working*/"
  }, {
    "id": "完整示例-complete-example",
    "content": "完整示例 /*complete-example*/"
  }]
};
import {Callout} from '#components/callout';
import {File, Folder, Files} from '#components/files';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
export const toc = [{
  depth: 2,
  url: "#入门-getting-started",
  title: _jsx(_Fragment, {
    children: "入门 "
  })
}, {
  depth: 3,
  url: "#创建-microfrontendsjson-create-microfrontendsjson",
  title: _jsxs(_Fragment, {
    children: ["创建 ", _jsx("code", {
      children: "microfrontends.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#设置应用端口-set-application-ports",
  title: _jsx(_Fragment, {
    children: "设置应用端口 "
  })
}, {
  depth: 3,
  url: "#处理基本路径-handle-base-paths",
  title: _jsx(_Fragment, {
    children: "处理基本路径 "
  })
}, {
  depth: 3,
  url: "#运行-turbo-dev-run-turbo-dev",
  title: _jsxs(_Fragment, {
    children: ["运行 ", _jsx("code", {
      children: "turbo dev"
    }), " "]
  })
}, {
  depth: 2,
  url: "#配置-configuration",
  title: _jsx(_Fragment, {
    children: "配置 "
  })
}, {
  depth: 3,
  url: "#developmentlocal-developmentlocal",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "development.local"
    }), " "]
  })
}, {
  depth: 3,
  url: "#developmentfallback-developmentfallback",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "development.fallback"
    }), " "]
  })
}, {
  depth: 3,
  url: "#routing-routing",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "routing"
    }), " "]
  })
}, {
  depth: 4,
  url: "#精确匹配-exact-matches",
  title: _jsx(_Fragment, {
    children: "精确匹配 "
  })
}, {
  depth: 4,
  url: "#参数-parameters",
  title: _jsx(_Fragment, {
    children: "参数 "
  })
}, {
  depth: 4,
  url: "#通配符-wildcards",
  title: _jsx(_Fragment, {
    children: "通配符 "
  })
}, {
  depth: 4,
  url: "#复杂的路由模式-complex-routing-patterns",
  title: _jsx(_Fragment, {
    children: "复杂的路由模式 "
  })
}, {
  depth: 4,
  url: "#分组标签-group-labels",
  title: _jsx(_Fragment, {
    children: "分组标签 "
  })
}, {
  depth: 3,
  url: "#packagename-packagename",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "packageName"
    }), " "]
  })
}, {
  depth: 3,
  url: "#optionslocalproxyport-optionslocalproxyport",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "options.localProxyPort"
    }), " "]
  })
}, {
  depth: 2,
  url: "#与生产环境集成-integrating-with-production",
  title: _jsx(_Fragment, {
    children: "与生产环境集成 "
  })
}, {
  depth: 3,
  url: "#vercel-上的微前端-microfrontends-on-vercel",
  title: _jsx(_Fragment, {
    children: "Vercel 上的微前端 "
  })
}, {
  depth: 4,
  url: "#迁移到-vercelmicrofrontends-migrating-to-vercelmicrofrontends",
  title: _jsxs(_Fragment, {
    children: ["迁移到 ", _jsx("code", {
      children: "@vercel/microfrontends"
    }), " "]
  })
}, {
  depth: 2,
  url: "#故障排除-troubleshooting",
  title: _jsx(_Fragment, {
    children: "故障排除 "
  })
}, {
  depth: 3,
  url: "#端口已被占用-port-already-in-use",
  title: _jsx(_Fragment, {
    children: "端口已被占用 "
  })
}, {
  depth: 3,
  url: "#缺少-css图片或其他资源或路由不匹配-missing-css-images-or-other-assets-or-routes-not-matching",
  title: _jsx(_Fragment, {
    children: "缺少 CSS、图片或其他资源，或路由不匹配 "
  })
}, {
  depth: 3,
  url: "#跨应用的链接导致错误-links-across-applications-causing-errors",
  title: _jsx(_Fragment, {
    children: "跨应用的链接导致错误 "
  })
}, {
  depth: 3,
  url: "#访问代理端口未重定向-visiting-a-proxied-port-does-not-redirect",
  title: _jsx(_Fragment, {
    children: "访问代理端口未重定向 "
  })
}, {
  depth: 3,
  url: "#应用无法启动-applications-not-starting",
  title: _jsx(_Fragment, {
    children: "应用无法启动 "
  })
}, {
  depth: 3,
  url: "#turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo get-mfe-port"
    }), " 无法正常工作 "]
  })
}, {
  depth: 2,
  url: "#完整示例-complete-example",
  title: _jsx(_Fragment, {
    children: "完整示例 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "微前端是一种架构模式，它将 Web 应用分解为更小的、独立开发和部署的应用，这些应用协同工作。"
    }), "\n", _jsx(_components.p, {
      children: "¥Microfrontends are an architectural pattern where a web application is decomposed into smaller, independently developed and deployed applications that work together."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 通过集成的代理服务器，为在开发过程中本地运行垂直微前端（有时称为 \"zones\"）提供了内置支持。代理协调多个应用并在它们之间路由流量。"
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo provides built-in support for running vertical microfrontends (sometimes called \"zones\") locally during development through an integrated proxy server. The proxy coordinates multiple applications and routes traffic between them."
    }), "\n", _jsx(_components.p, {
      children: "假设你有一个包含多个前端应用的单体仓库："
    }), "\n", _jsx(_components.p, {
      children: "¥Let's imagine you have a monorepo with multiple frontend applications:"
    }), "\n", _jsxs(Files, {
      children: [_jsxs(Folder, {
        name: "apps",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "web",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "next.config.js"
          })]
        }), _jsxs(Folder, {
          name: "docs",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "next.config.js"
          })]
        }), _jsxs(Folder, {
          name: "marketing",
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "vite.config.ts"
          })]
        })]
      }), _jsx(File, {
        name: "package.json"
      }), _jsx(File, {
        name: "turbo.json"
      })]
    }), "\n", _jsx(_components.p, {
      children: "在生产环境中，这些应用可以单独部署，然后使用反向代理或边缘路由组合在一起。但在开发过程中，你需要："
    }), "\n", _jsx(_components.p, {
      children: "¥In production, these applications might be deployed separately and composed together using a reverse proxy or edge routing. But during development, you want to:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "使用单个命令同时运行所有应用"
        }), "\n", _jsx(_components.p, {
          children: "¥Run all applications simultaneously with a single command"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["通过统一 URL（例如 ", _jsx(_components.code, {
            children: "http://localhost:3024"
          }), "）访问它们"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Access them through a unified URL (e.g., ", _jsx(_components.code, {
            children: "http://localhost:3024"
          }), ")"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "根据路径模式将请求路由到正确的应用"
        }), "\n", _jsx(_components.p, {
          children: "¥Route requests to the correct application based on path patterns"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "支持热模块重载和 WebSocket 连接。"
        }), "\n", _jsx(_components.p, {
          children: "¥Support hot module reloading and WebSocket connections"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "避免端口冲突和手动协调"
        }), "\n", _jsx(_components.p, {
          children: "¥Avoid port conflicts and manual coordination"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "入门-getting-started",
      children: "入门 "
    }), "\n", _jsx(_components.p, {
      children: "¥Getting started"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 提供了一个内置代理服务器，可在开发过程中自动路由微前端应用之间的流量。代理读取 ", _jsx(_components.code, {
        children: "microfrontends.json"
      }), " 配置文件，并在你运行 ", _jsx(_components.code, {
        children: "turbo dev"
      }), " 时启动。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo provides a built-in proxy server that automatically routes traffic between your microfrontend applications during development. The proxy reads a ", _jsx(_components.code, {
        children: "microfrontends.json"
      }), " configuration file and starts when you run ", _jsx(_components.code, {
        children: "turbo dev"
      }), "."]
    }), "\n", _jsxs(Callout, {
      children: [_jsxs(_components.p, {
        children: ["你可以尝试使用 ", _jsx(_components.code, {
          children: "npx create-turbo@latest -e with-microfrontends"
        }), " 创建的 monorepo 执行以下说明。"]
      }), _jsxs(_components.p, {
        children: ["¥You can try the following instructions with the monorepo created by ", _jsx(_components.code, {
          children: "npx     create-turbo@latest -e with-microfrontends"
        }), "."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "创建-microfrontendsjson-create-microfrontendsjson",
      children: ["创建 ", _jsx(_components.code, {
        children: "microfrontends.json"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Create ", _jsx(_components.code, {
        children: "microfrontends.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["在父应用中创建 ", _jsx(_components.code, {
        children: "microfrontends.json"
      }), " 文件。当没有其他应用匹配时，所有请求都将回退到此应用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Create a ", _jsx(_components.code, {
        children: "microfrontends.json"
      }), " file in your parent application. This application is the one that all requests will fall through to when not matched by another application."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turbo.nodejs.cn/microfrontends/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"applications\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"web\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"port\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3000"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"docs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"port\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3001"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"routing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        {"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"/docs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"/docs/:path*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "设置应用端口-set-application-ports",
      children: "设置应用端口 "
    }), "\n", _jsx(_components.p, {
      children: "¥Set application ports"
    }), "\n", _jsxs(_components.p, {
      children: ["接下来，使用 ", _jsx(_components.code, {
        children: "turbo get-mfe-port"
      }), " 命令在应用的开发脚本中设置端口。此命令在运行 ", _jsx(_components.code, {
        children: "turbo dev"
      }), " 时注入端口号："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Next, use the ", _jsx(_components.code, {
        children: "turbo get-mfe-port"
      }), " command to set the ports in your application's development scripts. This command injects the port number when running ", _jsx(_components.code, {
        children: "turbo dev"
      }), ":"]
    }), "\n", _jsxs(Tabs, {
      items: ['Next.js', 'Vite'],
      storageKey: "framework-preference",
      children: [_jsx(Tab, {
        value: "Next.js",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"next dev --port $(turbo get-mfe-port)\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "Vite",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"vite dev --port $TURBO_MFE_PORT\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h3, {
      id: "处理基本路径-handle-base-paths",
      children: "处理基本路径 "
    }), "\n", _jsx(_components.p, {
      children: "¥Handle base paths"
    }), "\n", _jsx(_components.p, {
      children: "如果你使用的是框架，请根据框架的要求设置基本路径。"
    }), "\n", _jsx(_components.p, {
      children: "¥If you're using a framework, set the base path according to the needs of the framework."
    }), "\n", _jsxs(Tabs, {
      items: ['Next.js', 'Vite'],
      storageKey: "framework-preference",
      children: [_jsx(Tab, {
        value: "Next.js",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/my-app/next.config.ts",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " type"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " { NextConfig } "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'next'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "const"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " nextConfig"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " NextConfig"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " ="
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  basePath"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " '/docs'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "};"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " default"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " nextConfig;"
                })]
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "Vite",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/my-app/vite.config.ts",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " { defineConfig } "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'vite'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " default"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " defineConfig"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "({"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  base"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " '/admin'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "});"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["有关框架特定指南，请参阅 ", _jsx(_components.a, {
        href: "/docs/guides/frameworks",
        children: "访问框架的微前端部分"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "/docs/guides/frameworks",
        children: "Visit the Microfrontends section of your framework"
      }), " for framework-specific guidance."]
    }), "\n", _jsxs(_components.h3, {
      id: "运行-turbo-dev-run-turbo-dev",
      children: ["运行 ", _jsx(_components.code, {
        children: "turbo dev"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Run ", _jsx(_components.code, {
        children: "turbo dev"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["运行 ", _jsx(_components.code, {
        children: "turbo dev"
      }), " 时，Turborepo 将执行以下操作："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When you run ", _jsx(_components.code, {
        children: "turbo dev"
      }), ", Turborepo will:"]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["在配置的端口上启动代理服务器（默认端口：", _jsx(_components.code, {
            children: "3024"
          }), "）。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Start the proxy server"
          }), " on the configured port (default: ", _jsx(_components.code, {
            children: "3024"
          }), ")"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["在任务中注入 ", _jsx(_components.code, {
            children: "TURBO_MFE_PORT"
          }), " 环境变量以设置应用的端口"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.strong, {
            children: ["Inject the ", _jsx(_components.code, {
              children: "TURBO_MFE_PORT"
            }), " environment variable"]
          }), " in tasks to set the applications' port"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "为所有已配置的应用运行开发任务"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Run development tasks"
          }), " for all configured applications"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "根据路径模式将传入请求路由到相应的应用"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Route incoming requests"
          }), " based on path patterns to the appropriate application"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["现在，你可以通过 ", _jsx(_components.code, {
        children: "http://localhost:3024"
      }), " 访问所有微前端应用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Now you can access all of your microfrontends applications at ", _jsx(_components.code, {
        children: "http://localhost:3024"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "配置-configuration",
      children: "配置 "
    }), "\n", _jsx(_components.p, {
      children: "¥Configuration"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "applications"
      }), " 对象中的每个应用都可以具有以下属性："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Each application in the ", _jsx(_components.code, {
        children: "applications"
      }), " object can have the following properties:"]
    }), "\n", _jsxs(_components.p, {
      children: ["如果未提供，则使用应用密钥来匹配 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中的名称。"]
    }), "\n", _jsx(_components.p, {
      children: "¥If not provided, the application key is used to match the name in `package.json."
    }), "\n", _jsxs(_components.h3, {
      id: "developmentlocal-developmentlocal",
      children: [_jsx(_components.code, {
        children: "development.local"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "应用在本地运行的端口。"
    }), "\n", _jsx(_components.p, {
      children: "¥The port where the application runs locally."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"port\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3000"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "如果省略端口，Turborepo 将根据应用名称生成一个确定的端口（介于 3000 到 8000 之间）。"
    }), "\n", _jsx(_components.p, {
      children: "¥If you omit the port, Turborepo will generate a deterministic port based on the application name (between 3000-8000)."
    }), "\n", _jsxs(_components.h3, {
      id: "developmentfallback-developmentfallback",
      children: [_jsx(_components.code, {
        children: "development.fallback"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["可选地，在应用未在本地运行时，提供要代理的目标。这最常用于将请求路由到生产环境，从而使像 ", _jsx(_components.code, {
        children: "turbo dev --filter=web"
      }), " 这样仅运行部分应用的命令获得无缝体验。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Optionally provide a target to proxy to when an application is not running locally. This is most frequently used to route to production to make commands like ", _jsx(_components.code, {
        children: "turbo dev --filter=web"
      }), " that only run a subset of applications a seamless experience."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"fallback\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"example.com\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "routing-routing",
      children: [_jsx(_components.code, {
        children: "routing"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "应路由到此应用的路径组数组。如果没有提供路由，则应用将成为默认应用，捕获所有未匹配的路由。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥An array of path groups that should route to this application. If no routing is provided, the application becomes the ", _jsx(_components.strong, {
        children: "default application"
      }), " that catches all unmatched routes."]
    }), "\n", _jsxs(_components.p, {
      children: ["只能有一个应用没有 ", _jsx(_components.code, {
        children: "routing"
      }), " 配置。这是你的 \"root\" 应用，用于处理所有其他应用未匹配的路由。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Only one application can have no ", _jsx(_components.code, {
        children: "routing"
      }), " configuration. This is your \"root\" application that handles all routes not matched by other applications."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"routing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    {"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"/api/:version/users/:id\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    {"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"/docs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"/docs/:path*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["路径区分大小写：", _jsx(_components.code, {
            children: "/Blog"
          }), " 和 ", _jsx(_components.code, {
            children: "/blog"
          }), " 是不同的路由"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Paths are ", _jsx(_components.strong, {
            children: "case-sensitive"
          }), ": ", _jsx(_components.code, {
            children: "/Blog"
          }), " and ", _jsx(_components.code, {
            children: "/blog"
          }), " are different routes"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["尾部斜杠已规范化：", _jsx(_components.code, {
            children: "/home"
          }), " 和 ", _jsx(_components.code, {
            children: "/home/"
          }), " 匹配同一路由"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Trailing slashes are normalized: ", _jsx(_components.code, {
            children: "/home"
          }), " and ", _jsx(_components.code, {
            children: "/home/"
          }), " match the same route"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h4, {
      id: "精确匹配-exact-matches",
      children: "精确匹配 "
    }), "\n", _jsx(_components.p, {
      children: "¥Exact matches"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"/pricing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"/about\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"/contact\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "这些路径与原文完全一致。"
    }), "\n", _jsx(_components.p, {
      children: "¥These paths match exactly as written."
    }), "\n", _jsx(_components.h4, {
      id: "参数-parameters",
      children: "参数 "
    }), "\n", _jsx(_components.p, {
      children: "¥Parameters"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"/blog/:slug\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"/users/:id/profile\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["以 ", _jsx(_components.code, {
        children: ":"
      }), " 开头的段匹配任何单个路径段。例如，", _jsx(_components.code, {
        children: "/blog/:slug"
      }), " 匹配 ", _jsx(_components.code, {
        children: "/blog/hello"
      }), "，但不匹配 ", _jsx(_components.code, {
        children: "/blog/hello/world"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Segments starting with ", _jsx(_components.code, {
        children: ":"
      }), " match any single path segment. For example, ", _jsx(_components.code, {
        children: "/blog/:slug"
      }), " matches ", _jsx(_components.code, {
        children: "/blog/hello"
      }), " but not ", _jsx(_components.code, {
        children: "/blog/hello/world"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "通配符-wildcards",
      children: "通配符 "
    }), "\n", _jsx(_components.p, {
      children: "¥Wildcards"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"/docs/:path*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"/api/:version*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["以 ", _jsx(_components.code, {
        children: "*"
      }), " 结尾的参数匹配零个或多个路径段。例如，", _jsx(_components.code, {
        children: "/docs/:path*"
      }), " 匹配 ", _jsx(_components.code, {
        children: "/docs"
      }), "、", _jsx(_components.code, {
        children: "/docs/intro"
      }), " 和 ", _jsx(_components.code, {
        children: "/docs/api/reference"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Parameters ending with ", _jsx(_components.code, {
        children: "*"
      }), " match zero or more path segments. For example, ", _jsx(_components.code, {
        children: "/docs/:path*"
      }), " matches ", _jsx(_components.code, {
        children: "/docs"
      }), ", ", _jsx(_components.code, {
        children: "/docs/intro"
      }), ", and ", _jsx(_components.code, {
        children: "/docs/api/reference"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["你还可以使用 ", _jsx(_components.code, {
        children: "+"
      }), " 修饰符来匹配一个或多个段（不包括空路径）："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can also use the ", _jsx(_components.code, {
        children: "+"
      }), " modifier to match one or more segments (excluding the empty path):"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"/api/:path+\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["这匹配 ", _jsx(_components.code, {
        children: "/api/users"
      }), " 和 ", _jsx(_components.code, {
        children: "/api/users/123"
      }), "，但不匹配 ", _jsx(_components.code, {
        children: "/api"
      }), " 或 ", _jsx(_components.code, {
        children: "/api/"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This matches ", _jsx(_components.code, {
        children: "/api/users"
      }), " and ", _jsx(_components.code, {
        children: "/api/users/123"
      }), ", but not ", _jsx(_components.code, {
        children: "/api"
      }), " or ", _jsx(_components.code, {
        children: "/api/"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "复杂的路由模式-complex-routing-patterns",
      children: "复杂的路由模式 "
    }), "\n", _jsx(_components.p, {
      children: "¥Complex routing patterns"
    }), "\n", _jsx(_components.p, {
      children: "你可以使用嵌套参数定义复杂的路由："
    }), "\n", _jsx(_components.p, {
      children: "¥You can define sophisticated routing with nested parameters:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"routing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    {"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \"/api/:version/users\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \"/api/:version/users/:id\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \"/api/:version/posts/:postId/comments/:commentId\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h4, {
      id: "分组标签-group-labels",
      children: "分组标签 "
    }), "\n", _jsx(_components.p, {
      children: "¥Group labels"
    }), "\n", _jsx(_components.p, {
      children: "将路由组织成逻辑组，以提高可维护性："
    }), "\n", _jsx(_components.p, {
      children: "¥Organize routes into logical groups for better maintainability:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turbo.nodejs.cn/microfrontends/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"applications\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"marketing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3002"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"routing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        {"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"group\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"blog\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"/blog\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"/blog/:slug*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        {"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"group\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"sales\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"/pricing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"/contact\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"/demo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "group"
      }), " 字段用于组织管理，不影响路由行为。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "group"
      }), " field is for organizational purposes and doesn't affect routing behavior."]
    }), "\n", _jsxs(_components.h3, {
      id: "packagename-packagename",
      children: [_jsx(_components.code, {
        children: "packageName"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["可选地，使用工作区中 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中的包名称。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Optionally use the name of the package from ", _jsx(_components.code, {
        children: "package.json"
      }), " in your workspace."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/main/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"applications\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"main-site\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"packageName\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"web\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "optionslocalproxyport-optionslocalproxyport",
      children: [_jsx(_components.code, {
        children: "options.localProxyPort"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["可选地，使用 ", _jsx(_components.code, {
        children: "localProxyPort"
      }), " 选项更改代理端口"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Optionally change the proxy port using the ", _jsx(_components.code, {
        children: "localProxyPort"
      }), " option"]
    }), "\n", _jsxs(_components.p, {
      children: ["默认为 ", _jsx(_components.code, {
        children: "3024"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Defaults to ", _jsx(_components.code, {
        children: "3024"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"options\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"localProxyPort\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 8080"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "与生产环境集成-integrating-with-production",
      children: "与生产环境集成 "
    }), "\n", _jsx(_components.p, {
      children: "¥Integrating with production"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 微前端代理仅供本地使用。你如何实现和集成生产微前端取决于你的生产基础架构。但是，我们可以集成你的本地环境和生产环境，从而创建跨环境的无缝体验。"
    }), "\n", _jsx(_components.p, {
      children: "¥The Turborepo microfrontends proxy is meant for local usage only. How you implement and integrate your production microfrontends depends on your production infrastructure. However, we can integrate your local and production environments to create a seamless experience across environments."
    }), "\n", _jsx(_components.p, {
      children: "首先，我们构建了 Turborepo 的本地代理，以便与 Vercel 的微前端集成。我们期待与任何有意集成 Vercel 的基础架构提供商合作。"
    }), "\n", _jsx(_components.p, {
      children: "¥To start, we've built Turborepo's local proxy to integrate with Vercel's microfrontends. We look forward to working with any infrastructure providers that would also like to integrate."
    }), "\n", _jsx(_components.h3, {
      id: "vercel-上的微前端-microfrontends-on-vercel",
      children: "Vercel 上的微前端 "
    }), "\n", _jsx(_components.p, {
      children: "¥Microfrontends on Vercel"
    }), "\n", _jsx(_components.p, {
      children: "Vercel 原生支持以下微前端："
    }), "\n", _jsx(_components.p, {
      children: "¥Vercel has native support for microfrontends that provide:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "增强性能的生产代理实现"
        }), "\n", _jsx(_components.p, {
          children: "¥Production proxy implementation with enhance performance"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "跨环境的回退 URL 支持。"
        }), "\n", _jsx(_components.p, {
          children: "¥Fallback URL support across environments"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Vercel 工具栏集成"
        }), "\n", _jsx(_components.p, {
          children: "¥Vercel toolbar integration"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "功能标志支持"
        }), "\n", _jsx(_components.p, {
          children: "¥Feature flag support"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "资源前缀处理"
        }), "\n", _jsx(_components.p, {
          children: "¥Asset prefix handling"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com/docs/microfrontends",
        children: "Vercel 文档：了解更多信息"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "https://vercel.com/docs/microfrontends",
        children: "Learn more in Vercel's documentation"
      }), "."]
    }), "\n", _jsxs(_components.h4, {
      id: "迁移到-vercelmicrofrontends-migrating-to-vercelmicrofrontends",
      children: ["迁移到 ", _jsx(_components.code, {
        children: "@vercel/microfrontends"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Migrating to ", _jsx(_components.code, {
        children: "@vercel/microfrontends"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["如果在任何包中安装 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/@vercel/microfrontends",
        children: _jsx(_components.code, {
          children: "@vercel/microfrontends"
        })
      }), " 或将其添加到你的工作区，Turborepo 将自动使用它，而不是使用内置代理。这允许逐步迁移。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you install ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/@vercel/microfrontends",
        children: _jsx(_components.code, {
          children: "@vercel/microfrontends"
        })
      }), " in any package or add it to your workspace, Turborepo will automatically defer to it instead of using the built-in proxy. This allows for a gradual migration path."]
    }), "\n", _jsxs(_components.p, {
      children: ["你可以使用与 Turborepo 相同的 ", _jsx(_components.code, {
        children: "microfrontends.json"
      }), " 配置。Turborepo 的 ", _jsx(_components.code, {
        children: "microfrontends.json"
      }), " 架构是 Vercel 架构的子集，因此与 ", _jsx(_components.code, {
        children: "@vercel/microfrontends"
      }), " 兼容。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can use the same ", _jsx(_components.code, {
        children: "microfrontends.json"
      }), " configuration as for Turborepo. Turborepo's ", _jsx(_components.code, {
        children: "microfrontends.json"
      }), " schema is a subset of Vercel's schema, so it is compatible with ", _jsx(_components.code, {
        children: "@vercel/microfrontends"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["了解更多关于 ", _jsx(_components.code, {
        children: "@vercel/microfrontends"
      }), " 和 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/@vercel/microfrontends",
        children: "访问 npm 上的软件包"
      }), " 的信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To learn more about ", _jsx(_components.code, {
        children: "@vercel/microfrontends"
      }), ", ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/@vercel/microfrontends",
        children: "visit the package on npm"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "故障排除-troubleshooting",
      children: "故障排除 "
    }), "\n", _jsx(_components.p, {
      children: "¥Troubleshooting"
    }), "\n", _jsx(_components.h3, {
      id: "端口已被占用-port-already-in-use",
      children: "端口已被占用 "
    }), "\n", _jsx(_components.p, {
      children: "¥Port already in use"
    }), "\n", _jsxs(_components.p, {
      children: ["默认情况下，微前端代理将尝试使用端口 3024。如果你已将该端口用于其他用途，则可以使用 ", _jsx(_components.a, {
        href: "#optionslocalproxyport",
        children: _jsx(_components.code, {
          children: "options.localProxyPort"
        })
      }), " 更改 Turborepo 的端口。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥By default, the microfrontends proxy will try to use port 3024. If you already use that port for a different purpose, you can change Turborepo's port using the ", _jsx(_components.a, {
        href: "#optionslocalproxyport",
        children: _jsx(_components.code, {
          children: "options.localProxyPort"
        })
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "缺少-css图片或其他资源或路由不匹配-missing-css-images-or-other-assets-or-routes-not-matching",
      children: "缺少 CSS、图片或其他资源，或路由不匹配 "
    }), "\n", _jsx(_components.p, {
      children: "¥Missing CSS, images, or other assets, or routes not matching"
    }), "\n", _jsxs(_components.p, {
      children: ["确保微前端在其 ", _jsxs(_components.a, {
        href: "#routing",
        children: [_jsx(_components.code, {
          children: "routing"
        }), " 配置"]
      }), " 中匹配的路径包含资源的路由。检查你的网络选项卡，查找与预期匹配或不匹配的路径。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Ensure that the paths that the microfrontends matches for in its ", _jsxs(_components.a, {
        href: "#routing",
        children: [_jsx(_components.code, {
          children: "routing"
        }), " configuration"]
      }), " include the routes for the assets. Check your network tab to find paths that are or aren't matching as expected."]
    }), "\n", _jsx(_components.h3, {
      id: "跨应用的链接导致错误-links-across-applications-causing-errors",
      children: "跨应用的链接导致错误 "
    }), "\n", _jsx(_components.p, {
      children: "¥Links across applications causing errors"
    }), "\n", _jsxs(_components.p, {
      children: ["如果使用单页应用 (SPA) 链接（例如 Next.js ", _jsx(_components.code, {
        children: "<Link>"
      }), " 组件）进行跨应用链接，则可能会导致错误。即使端口和域名保持不变，应用也是不同的。这意味着根据定义，该路由不是 \"单页应用\"。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you use a Single-Page Application (SPA) link (like the Next.js ", _jsx(_components.code, {
        children: "<Link>"
      }), " component) to link across applications, this can result in errors. Even though the port and domain remain the same, the applications are different. This means the routing is, by definition, not a \"single-page application\"."]
    }), "\n", _jsx(_components.h3, {
      id: "访问代理端口未重定向-visiting-a-proxied-port-does-not-redirect",
      children: "访问代理端口未重定向 "
    }), "\n", _jsx(_components.p, {
      children: "¥Visiting a proxied port does not redirect"
    }), "\n", _jsxs(_components.p, {
      children: ["你仍然可以直接访问代理端口。例如，如果 ", _jsx(_components.code, {
        children: "localhost:3000"
      }), " 被代理到 ", _jsx(_components.code, {
        children: "localhost:3042"
      }), "，你仍然可以在浏览器中访问 ", _jsx(_components.code, {
        children: "localhost:3000"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You are still be able to reach a proxied port directly. For example, if ", _jsx(_components.code, {
        children: "localhost:3000"
      }), " is proxied to ", _jsx(_components.code, {
        children: "localhost:3042"
      }), ", you can still visit ", _jsx(_components.code, {
        children: "localhost:3000"
      }), " in your browser."]
    }), "\n", _jsxs(_components.p, {
      children: ["如果你希望 ", _jsx(_components.code, {
        children: "localhost:3000"
      }), " 重定向到 ", _jsx(_components.code, {
        children: "localhost:3024"
      }), "，则必须在应用中手动设置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you would like for ", _jsx(_components.code, {
        children: "localhost:3000"
      }), " to redirect to ", _jsx(_components.code, {
        children: "localhost:3024"
      }), ", you must set this up manually in your application."]
    }), "\n", _jsx(_components.h3, {
      id: "应用无法启动-applications-not-starting",
      children: "应用无法启动 "
    }), "\n", _jsx(_components.p, {
      children: "¥Applications not starting"
    }), "\n", _jsx(_components.p, {
      children: "验证以下内容："
    }), "\n", _jsx(_components.p, {
      children: "¥Verify that:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "packageName"
          }), " 与你的实际包名匹配。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "packageName"
          }), " matches your actual package name"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["指定的 ", _jsx(_components.code, {
            children: "task"
          }), " 存在于包的 ", _jsx(_components.code, {
            children: "package.json"
          }), " 中。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "task"
          }), " specified exists in the package's ", _jsx(_components.code, {
            children: "package.json"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "每个应用的端口都可用。"
        }), "\n", _jsx(_components.p, {
          children: "¥Each application's port is available"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "所有依赖均已安装"
        }), "\n", _jsx(_components.p, {
          children: "¥All dependencies are installed"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.h3, {
      id: "turbo-get-mfe-port-无法正常工作-turbo-get-mfe-port-not-working",
      children: [_jsx(_components.code, {
        children: "turbo get-mfe-port"
      }), " 无法正常工作 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo get-mfe-port"
      }), " not working"]
    }), "\n", _jsxs(_components.p, {
      children: ["如果在运行 ", _jsx(_components.code, {
        children: "turbo get-mfe-port"
      }), " 时遇到错误，请确保："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you're getting an error when running ", _jsx(_components.code, {
        children: "turbo get-mfe-port"
      }), ", ensure that:"]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "你正在从包目录（而非仓库根目录）运行命令。"
        }), "\n", _jsx(_components.p, {
          children: "¥You're running the command from a package directory (not the repository root)"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["包的 ", _jsx(_components.code, {
            children: "package.json"
          }), " 中包含 ", _jsx(_components.code, {
            children: "name"
          }), " 字段。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥The package has a ", _jsx(_components.code, {
            children: "name"
          }), " field in its ", _jsx(_components.code, {
            children: "package.json"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["某个包中存在 ", _jsx(_components.code, {
            children: "microfrontends.json"
          }), " 文件"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥A ", _jsx(_components.code, {
            children: "microfrontends.json"
          }), " file exists in one of the packages"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["当前包列在 ", _jsx(_components.code, {
            children: "microfrontends.json"
          }), " 的 ", _jsx(_components.code, {
            children: "applications"
          }), " 部分。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥The current package is listed in the ", _jsx(_components.code, {
            children: "applications"
          }), " section of ", _jsx(_components.code, {
            children: "microfrontends.json"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果使用 ", _jsx(_components.code, {
            children: "--skip-infer"
          }), "，则还必须指定指向仓库根目录的 ", _jsx(_components.code, {
            children: "--cwd"
          }), "："]
        }), "\n", _jsxs(_components.p, {
          children: ["¥If using ", _jsx(_components.code, {
            children: "--skip-infer"
          }), ", you must also specify ", _jsx(_components.code, {
            children: "--cwd"
          }), " pointing to your repository root:"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --skip-infer"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cwd"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ../.."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " get-mfe-port"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "完整示例-complete-example",
      children: "完整示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Complete example"
    }), "\n", _jsx(_components.p, {
      children: "以下是一个完整的电子商务平台微前端配置示例："
    }), "\n", _jsx(_components.p, {
      children: "¥Here's a full example of a microfrontends configuration for an e-commerce platform:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turbo.nodejs.cn/microfrontends/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"options\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"localProxyPort\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3024"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"applications\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"web\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"packageName\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"web\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"port\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3000"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"docs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"packageName\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"documentation\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"port\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3001"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"routing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        {"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"group\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"documentation\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/docs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/docs/:path*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/api-reference\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/api-reference/:path*\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "          ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"blog\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"port\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3002"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"routing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        {"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"group\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"content\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/blog\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/blog/:slug\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/blog/category/:category\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/authors/:author\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "          ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"shop\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"port\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3003"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"routing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        {"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"group\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"commerce\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/products\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/products/:id\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/cart\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/checkout\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "            \"/orders/:orderId\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "          ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "使用此配置："
    }), "\n", _jsx(_components.p, {
      children: "¥With this configuration:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "web"
          }), " 应用处理首页和任何未匹配的路由。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "web"
          }), " app handles the homepage and any unmatched routes"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "docs"
          }), " 应用处理所有文档。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "docs"
          }), " app handles all documentation"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "blog"
          }), " 应用处理博客文章和作者页面。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "blog"
          }), " app handles blog posts and author pages"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "shop"
          }), " 应用处理电子商务功能。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "shop"
          }), " app handles e-commerce functionality"]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
